import { jsx as s } from "react/jsx-runtime";
import { Icon as a } from "@chakra-ui/react";
import { Check as n } from "./icons/check.js";
import { Minus as m } from "./icons/minus.js";
import { Plus as f } from "./icons/plus.js";
function p(o, c, r) {
  if (c && !r)
    switch (o) {
      case "sm":
        return "9px";
      case "md":
      default:
        return "10px";
    }
  switch (o) {
    case "sm":
      return "14px";
    case "md":
      return "16px";
    case "lg":
      return "18px";
    default:
      return "18px";
  }
}
function w({
  variant: o,
  size: c,
  isChecked: r,
  isIndeterminate: e
}) {
  if (!r && o === "normal" && !e) return null;
  let t;
  const u = p(c, e, r);
  switch (!0) {
    case r:
      t = n;
      break;
    case o === "addon":
      t = f;
      break;
    case e:
      t = m;
      break;
    default:
      t = n;
      break;
  }
  return /* @__PURE__ */ s(a, { as: t, boxSize: u });
}
export {
  w as CheckboxIcon
};
